import React from 'react';
import bemHelper from 'react-bem-helper';

import { replaceStyleImageUri } from '../../utils';
import * as constants from '../../constants';
import SectionTextModule from './../SectionTextModule/SectionTextModule';
import './styles.scss';

const bem = bemHelper({ prefix: 'toga-', name: 'storefront-story' });

class OurStoryModule extends React.Component {

  render() {
    const { images = [], title, summary, text } = this.props;

    const oneImage = images.length === 1;
    const threeImages = images.length === 3;
    const noImages = !images.length;

    const modifiers = {
      'one-image': oneImage,
      'no-images': noImages,
      'three-images': threeImages,
    };

    return (
      <div {...bem()}>
        <SectionTextModule {...bem('text', modifiers)} title={title} summary={summary} body={text}/>
        <div {...bem('images', modifiers)}>
          {
            images && images.map((image, index) => {
              return image.url && <img
                  key={index} {...bem(`image${index + 1}`, modifiers)}
                  srcSet={`${replaceStyleImageUri(image.url, constants.IMAGE_SIZE_NORMAL)}, ${replaceStyleImageUri(image.url, constants.IMAGE_SIZE_RETINA)} 2x`}
                  src={replaceStyleImageUri(image.url, constants.IMAGE_SIZE_NORMAL)}
                  alt={image.altText}/>;
            })
          }
        </div>
      </div>
    );
  }

}

export default OurStoryModule;




// WEBPACK FOOTER //
// ./src/components/storefront/components/OurStoryModule/OurStoryModule.js